import React from 'react'

const AppStoreBadge = () => {
  return (
    <div>
        <img src={"AppStoreBadge.png"} alt="" />
    </div>
  )
}

export default AppStoreBadge